import thunkMiddleware from 'redux-thunk';
import { createStore, applyMiddleware } from 'redux';
import combineReducers from 'reducers';
const reducers = combineReducers();
let middleware = [thunkMiddleware];
if (process.env.NODE_ENV !== 'production') {
	const CreateLogger = require('redux-logger');
	middleware = [...middleware, CreateLogger.createLogger()];
}

let store;
store = createStore(
	reducers,
	applyMiddleware(...middleware)
);
export default store;
